import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import "./index.css";
import AddNewComponentFooter from "Pages/StudentPortfolio/StudentPortfolioMobile/AddNewComponentFooter";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import { useForm } from "react-hook-form";
import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { StudentContext } from "Context/StudentContext";
import { useContext } from "react";
import {
  StyledSpanRating,
  getIndicatorColor,
} from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentRatingComponent";
const StudentPortfolioSlider = ({
  commentsObj,
  isPaneOpen,
  onRequestClose,
  setisPaneOpen,
  children,
  addCommentHandler,
  viewCommentHandler,
  tabs,
  component,
  setComponent,
}: any) => {
  const { selectedStudent, lopDetails } = useContext<any>(StudentContext);
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  console.log(tabs);
  return (
    <Offcanvas
      backdrop={true}
      className="w-100 filterSlider"
      isOpen={isPaneOpen}
      direction="end"
      toggle={onRequestClose}
    >
      <OffcanvasHeader className="filterHeader w-100">
        <div className="d-flex justify-content-between w-100 filterSliderPaneHeaderStyle">
          <div className="d-flex">
            <LeftArrow
              className={"cursorHoverCSS mr-2"}
              onClick={() => {
                setisPaneOpen(!isPaneOpen);
              }}
            />
            <img
              className={"profileImageMobile"}
              id="selected-image"
              src={selectedStudent?.imageUrl}
            />
            <Typography variant={"h6"} color="black">
              {selectedStudent?.name}
            </Typography>
          </div>
          <div>
            <StyledSpanRating
              color={getIndicatorColor(
                (lopDetails && lopDetails.probability * 100) || 0
              )}
              screen={screen}
            >
              {lopDetails && lopDetails.segment}
            </StyledSpanRating>
          </div>
        </div>
      </OffcanvasHeader>
      <OffcanvasBody className="studentOffcanvasBody">
        <div className="selectDiv">
          <SingleSelectHookForm
            disabled={false}
            error={errors}
            controlName={control}
            placeholder="Select role"
            width="50%"
            isInPerformance={false}
            options={tabs}
            menuPlacement="bottom"
            isClearable={false}
            isSearchable={true}
            isSearchableDrop={true}
            isDropdownSelect={true}
            top={"0px"}
            menuShouldScrollIntoView={true}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            name={"fexRole"}
            register={register}
            rules={{
              required: "You must select user role.",
            }}
            onChange={(selected: any) => {
              console.log("selected", selected);
              setComponent(selected);
            }}
            defaultValue={[component]}
          />
        </div>
        <div style={{ marginTop: "72px" }}>{children}</div>
      </OffcanvasBody>
      <AddNewComponentFooter
        selectedStudent={selectedStudent}
        commentsObj={commentsObj}
        addCommentHandler={addCommentHandler}
        viewCommentHandler={viewCommentHandler}
      />
    </Offcanvas>
  );
};
export default StudentPortfolioSlider;
